module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-latin366.25fc9f7.woff2";